import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "../config/brand";

const Section = ({ n, title, children }) => (
  <section className="mb-9">
    <h2 className="font-display text-xl lg:text-2xl font-semibold text-white tracking-tight mb-3 flex items-baseline gap-3">
      <span className="text-primary-red text-sm font-bold tracking-[0.2em]">
        §{n}
      </span>
      <span>{title}</span>
    </h2>
    <div className="font-body text-sm lg:text-base text-zinc-300 leading-relaxed">
      {children}
    </div>
  </section>
);

const AGB = () => {
  useEffect(() => {
    document.title = "AGB · LionPerformance";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="page-agb" className="min-h-screen bg-black text-white">
      <header className="border-b border-white/5">
        <div className="mx-auto max-w-[900px] px-6 lg:px-8 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src={BRAND.logo}
              alt="LionPerformance"
              className="h-9 w-9 object-contain"
              style={{ filter: "url(#lp-remove-black)" }}
            />
            <span className="font-display text-white text-base font-semibold tracking-tight">
              Lion<span className="text-primary-red">Performance</span>
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-zinc-300 hover:text-primary-red transition-colors"
          >
            <ArrowLeft size={14} />
            Zurück
          </Link>
        </div>
      </header>

      <article className="mx-auto max-w-[900px] px-6 lg:px-8 py-14 lg:py-20">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-primary-red" />
          <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-zinc-400">
            Rechtliches
          </span>
        </div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold text-white tracking-tight leading-[1.05] mb-4">
          Allgemeine Geschäftsbedingungen
        </h1>
        <p className="text-sm text-zinc-500 mb-12">Lion Performance · Marc Wiebeck</p>

        <Section n={1} title="Geltungsbereich">
          <p>
            Diese AGB gelten für sämtliche Coaching-, Beratungs- und
            Bildungsleistungen von Lion Performance, Inhaber Marc Wiebeck,
            gegenüber Verbrauchern und Unternehmern.
          </p>
        </Section>

        <Section n={2} title="Leistungen">
          <p>
            Angeboten werden insbesondere sportpsychologische Betreuung,
            Mental Coaching, High Performance Coaching, Ernährungsberatung,
            Trainingsplanung, Online- und Vor-Ort-Coaching, Workshops,
            Vorträge, Leistungsdiagnostik, digitale Handouts und Online-Kurse.
          </p>
        </Section>

        <Section n={3} title="Vertragsschluss">
          <p>
            Verträge kommen ausschließlich durch individuelles Angebot und
            ausdrückliche Annahme zustande. Die Website stellt kein
            verbindliches Angebot dar.
          </p>
        </Section>

        <Section n={4} title="Vergütung">
          <p>
            Es gelten die individuell vereinbarten Preise. Rechnungen sind
            innerhalb der vereinbarten Frist ohne Abzug fällig.
          </p>
        </Section>

        <Section n={5} title="Termine">
          <p>
            Vereinbarte Termine sind verbindlich. Terminverschiebungen sind
            im gegenseitigen Einvernehmen möglich.
          </p>
        </Section>

        <Section n={6} title="Mitwirkungspflichten">
          <p>
            Der Kunde stellt alle für die Leistung erforderlichen
            Informationen vollständig und wahrheitsgemäß bereit.
          </p>
        </Section>

        <Section n={7} title="Gesundheit">
          <p>
            Coaching ersetzt keine ärztliche, psychotherapeutische oder
            heilkundliche Behandlung. Gesundheitliche Einschränkungen sind
            vor Beginn mitzuteilen.
          </p>
        </Section>

        <Section n={8} title="Haftung">
          <p>
            Es wird nach den gesetzlichen Vorschriften gehaftet. Für den
            Eintritt bestimmter Trainings-, Gesundheits- oder
            Leistungserfolge wird keine Garantie übernommen.
          </p>
        </Section>

        <Section n={9} title="Urheberrecht">
          <p>
            Unterlagen, Handouts und Konzepte sind urheberrechtlich geschützt
            und dürfen ohne Zustimmung nicht vervielfältigt oder
            weitergegeben werden.
          </p>
        </Section>

        <Section n={10} title="Datenschutz">
          <p>
            Es gilt die gesonderte{" "}
            <Link
              to="/datenschutz"
              className="text-white underline underline-offset-4 hover:text-primary-red transition-colors"
            >
              Datenschutzerklärung
            </Link>
            .
          </p>
        </Section>

        <Section n={11} title="Schlussbestimmungen">
          <p>Es gilt deutsches Recht, soweit gesetzlich zulässig.</p>
        </Section>

        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-zinc-600">
            © {new Date().getFullYear()} Lion Performance. Alle Rechte
            vorbehalten.
          </div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 hover:text-primary-red transition-colors"
          >
            <ArrowLeft size={14} />
            Zurück zur Startseite
          </Link>
        </div>
      </article>
    </main>
  );
};

export default AGB;
